﻿import LazyLoad from "vanilla-lazyload";

window.LazyLoad = LazyLoad;